import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateCommunityFailure,
  CreateCommunityRequest,
  CreateCommunitySuccess,
  DeleteCommunityFailure,
  DeleteCommunityRequest,
  DeleteCommunitySuccess,
  FetchCommunitiesFailure,
  FetchCommunitiesRequest,
  FetchCommunitiesSuccess,
  FetchCommunityFailure,
  FetchCommunityRequest,
  FetchCommunitySuccess,
  UpdateCommunityFailure,
  UpdateCommunityRequest,
  UpdateCommunitySuccess,
} from './communities.actions'
import { CommunitiesService } from './communities.service'
import * as CommunitiesTypes from './communities.types'

@Injectable()
export class CommunitiesEffects {
  constructor(
    private actions: Actions,
    private communitiesService: CommunitiesService,
    private router: Router,
  ) {}

  FetchCommunities$ = createEffect(() =>
    this.actions.pipe(
      ofType(CommunitiesTypes.FETCH_COMMUNITIES_REQUEST),
      switchMap((action: FetchCommunitiesRequest) => {
        return this.communitiesService.fetchCommunities(action.payload).pipe(
          map((result) => {
            return new FetchCommunitiesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchCommunitiesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchCommunity$ = createEffect(() =>
    this.actions.pipe(
      ofType(CommunitiesTypes.FETCH_COMMUNITY_REQUEST),
      switchMap((action: FetchCommunityRequest) => {
        return this.communitiesService.fetchCommunity(action.id).pipe(
          map((result) => {
            return new FetchCommunitySuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchCommunityFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteCommunity$ = createEffect(() =>
    this.actions.pipe(
      ofType(CommunitiesTypes.DELETE_COMMUNITY_REQUEST),
      switchMap((action: DeleteCommunityRequest) => {
        return this.communitiesService.deleteCommunity(action.id).pipe(
          switchMap((result) => {
            return [new DeleteCommunitySuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteCommunityFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateCommunity$ = createEffect(() =>
    this.actions.pipe(
      ofType(CommunitiesTypes.CREATE_COMMUNITY_REQUEST),
      switchMap((action: CreateCommunityRequest) => {
        return this.communitiesService.createCommunity(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/communities'])
            return [new CreateCommunitySuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateCommunityFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateCommunity$ = createEffect(() =>
    this.actions.pipe(
      ofType(CommunitiesTypes.UPDATE_COMMUNITY_REQUEST),
      switchMap((action: UpdateCommunityRequest) => {
        return this.communitiesService
          .updateCommunity(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/communities'])
              return [new UpdateCommunitySuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateCommunityFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
